<template>
    <div class="banner-checkout">
        <div class="container">
            <div class="row">
                <div class="col-md-8 col-lg-9">
                    <div class="banner-checkout__summary">
                        <h4>{{ $t('banner_checkout.total', { grandTotal: getGrandTotalFormatted }) }}</h4>
                        {{ getGrandTotal > 0 ? $t('banner_checkout.subtitle') : $t('banner_checkout.subtitle_free_photos') }}
                    </div>
                </div>

                <div class="col-md-4 col-lg-3 text-right">
                    <router-link :to="{ name: 'checkout'}" class="btn btn-primary btn--checkout">
                        {{ $t('pages.configuration_finished.action_checkout') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex'
    export default {
        computed: {
            ...mapGetters('cart', [
                'getGrandTotalFormatted',
                'getGrandTotal'
            ])
        }
    }
</script>
